import { Component, HostListener, Input } from '@angular/core';
import { Color } from '../../../constants/color.constants';
import { IconPaths } from '../../../constants/icons.constants';

/**
 * @group Basic Toolkit
 * @component Icon
 */
@Component({
    selector: 'lsq-icon',
    template: `
        <svg-icon
            [src]="iconPaths[type]"
            [ngClass]="[
                type + '-icon',
                color ? 'text-' + (isHover && hoverColor ? hoverColor : color) : ''
            ]"
            [svgStyle]="{
                width: width + 'px',
                height: height + 'px'
            }"
        >
        </svg-icon>

        <span *ngIf="showBeta" class="beta-text">beta</span>
    `,
    styleUrls: ['./lsq-icon.component.scss']
})
export class LsqIconComponent {
    @Input() public type: string;
    @Input() public width?: number;
    @Input() public height?: number;
    @Input() public showBeta = false;
    @Input() public color?: Color;
    @Input() public hoverColor?: Color;
    public isHover = false;
    public iconPaths = IconPaths;

    @HostListener('mouseenter') public onHoverEnter(): void {
        this.isHover = true;
    }

    @HostListener('mouseleave') public onHoverLeave(): void {
        this.isHover = false;
    }
}
